import { OfflineReview } from './offlineDatabase';
import { ReviewStatus } from '../types';

export interface OfflineAddressSuggestion {
  propertyId: number;
  address: string;
  lastUsed: Date;
}

interface OfflineAddressCacheDatabase {
  getReviewsByProperty(
    propertyId: number,
    options?: {
      status?: ReviewStatus;
      limit?: number;
    }
  ): Promise<OfflineReview[]>;
  getPropertyIdByNormalizedAddress(address: string): Promise<number | null>;
  getRecentAddresses(limit?: number): Promise<Array<OfflineAddressSuggestion & {
    status: ReviewStatus;
  }>>;
}

export class OfflineAddressCacheService {
  constructor(private readonly database: OfflineAddressCacheDatabase) {}

  async getLatestAddressForProperty(propertyId: number): Promise<string | null> {
    try {
      const reviews = await this.database.getReviewsByProperty(propertyId, { limit: 1 });

      if (reviews.length === 0) {
        return null;
      }

      return reviews[0].address || null;
    } catch (error) {
      console.warn('[OfflineAddressCacheService] Error getting latest address for property:', error);
      return null;
    }
  }

  async getPropertyIdForAddress(address: string): Promise<number | null> {
    try {
      return await this.database.getPropertyIdByNormalizedAddress(address);
    } catch (error) {
      console.warn('[OfflineAddressCacheService] Error getting property ID for address:', error);
      return null;
    }
  }

  async getCachedAddresses(limit: number = 50): Promise<OfflineAddressSuggestion[]> {
    try {
      const addressData = await this.database.getRecentAddresses(limit);

      return addressData.map(data => ({
        propertyId: data.propertyId,
        address: data.address,
        lastUsed: data.lastUsed,
      }));
    } catch (error) {
      console.warn('[OfflineAddressCacheService] Error getting cached addresses:', error);
      return [];
    }
  }
}
